import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["info", "form", "trigger"]

  showForm(event) {
    event.preventDefault()
    this.infoTarget.style.display = "none"
    this.formTarget.style.display = ""
    this.triggerTarget.setAttribute("aria-expanded", "true")
    this.formTarget.querySelector("input")?.focus()
  }

  hideForm(event) {
    event.preventDefault()
    this.formTarget.style.display = "none"
    this.infoTarget.style.display = ""
    this.triggerTarget.setAttribute("aria-expanded", "false")
    this.triggerTarget.focus()
  }
}
